import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Iter144 — Register the PWA service worker so SenrizeFlow can be
// installed to the home screen and launch in standalone mode. Only
// activates in production because CRA's HMR conflicts with service
// workers in dev.
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .catch((err) => {
        // Non-fatal — the app still works without offline shell caching.
        // eslint-disable-next-line no-console
        console.warn("[PWA] Service worker registration failed:", err);
      });
  });
}
